import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { EMPTY, tap } from "rxjs";
import { catchError } from "rxjs/operators";
import { HelpdeskToolkitApiService } from "../services/helpdesk-toolkit-api.service";
import { HelpdeskToolkitActions } from "./helpdesk-toolkit.actions";

interface HelpdeskToolkitStateModel {
    isTest: boolean;
}

const defaultState: HelpdeskToolkitStateModel = {
    isTest: false,
};

@State<HelpdeskToolkitStateModel>({
    name: "helpdeskToolkit",
    defaults: defaultState,
})
@Injectable()
export class HelpdeskToolkitState {
    constructor(private readonly helpdeskToolkitApiService: HelpdeskToolkitApiService) {}

    @Selector()
    public static isTest(state: HelpdeskToolkitStateModel): boolean {
        return state.isTest;
    }

    @Action(HelpdeskToolkitActions.Test)
    public test(context: StateContext<HelpdeskToolkitStateModel>, action: HelpdeskToolkitActions.Test) {
        return this.helpdeskToolkitApiService.test().pipe(
            tap(() => {
                context.patchState({
                    isTest: action.isTest,
                });
            }),
            catchError((error) => {
                context.patchState({ isTest: false });

                return EMPTY;
            })
        );
    }
}
